import { render, staticRenderFns } from "./SmartGasBackground.vue?vue&type=template&id=60be8d22&scoped=true"
import script from "./SmartGasBackground.vue?vue&type=script&lang=js"
export * from "./SmartGasBackground.vue?vue&type=script&lang=js"
import style0 from "./SmartGasBackground.vue?vue&type=style&index=0&id=60be8d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60be8d22",
  null
  
)

export default component.exports